<template>
  <div>
    <v-menu offset-y
            left
            max-width="320"
            min-width="260"
            v-if="isAuthenticated">
      <template v-slot:activator="{ on }">
        <v-btn class="sf-account-btn"
               v-bind:icon="$vuetify.breakpoint.smAndDown"
               v-bind:text="$vuetify.breakpoint.mdAndUp"
               v-on="on">
          <v-avatar class="sf-account-btn__avatar"
                    size="28">
            <img alt=""
                 v-bind:src="picture"
                 v-if="picture">
            <v-icon v-else>ti-user-circle</v-icon>
          </v-avatar>
          <span class="hidden-sm-and-down ml-2">{{ displayName }}</span>
          <v-icon class="hidden-sm-and-down"
                  right
                  small>ti-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img alt=""
                 v-bind:src="picture">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">{{ displayName }}</v-list-item-title>
            <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-1" />

        <slot />

        <v-list-item v-on:click="$emit('sign-out')">
          <v-list-item-icon class="mr-3">
            <v-icon color="accent">ti-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="accent--text">{{ $t('signOut') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn v-bind:icon="$vuetify.breakpoint.smAndDown"
           v-bind:text="$vuetify.breakpoint.mdAndUp"
           v-else
           v-on:click="$emit('sign-in')">
      <v-icon v-bind:left="$vuetify.breakpoint.mdAndUp">ti-login-2</v-icon>
      <span class="hidden-sm-and-down text-truncate">{{ $t('signIn') }}</span>
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'AccountBlock',
    props: {
      displayName: String,
      email: String,
      isAuthenticated: Boolean,
      picture: String
    }
  }
</script>

<style scoped>
  .sf-account-btn.v-btn--text {
    padding: 0 8px 0 6px !important;
  }

  .sf-account-btn__avatar {
    background: var(--sf-primary-soft);
    color: var(--sf-primary);
  }
</style>

<i18n>
  {
    "de": {
      "signIn": "Anmelden",
      "signOut": "Abmelden"
    },
    "en": {
      "signIn": "Sign in",
      "signOut": "Sign out"
    }
  }
</i18n>
